export default function VSCode() {
  return (
    <iframe
      className="h-full w-full bg-vscode"
      src="https://code.rocke.top/?folder=%2Fhome%2Flouis"
      frameBorder="0"
      title="VSCode"
    />
  );
}
